export default __webpack_public_path__ + "static/Shopify_Plus-c5a920f4401a6cd7a6cd517ebe6eff91.svg";